import React, { useEffect, useState,useRef } from 'react'
import LiveLike from "@livelike/engagementsdk";
import {useDispatch, useSelector} from "react-redux";
import {listenGroup} from "../../../services/syncService";
import {setRemoteGroup} from "../../../store/reducers/chatReducer";
import blueRobot from "../../../assets/images/bluerobot.png";
import useIsMobilePlatform from "../../../hooks/useIsMobilePlatform";

const GroupChat = ({userProfile, avatar }) => {

    const dispatch = useDispatch();
    const { userName, roomLink } = useSelector(state => state.participant);
    const { remoteGroup, chatUserProfile } = useSelector(state => state.chat );
    const { participants } = useSelector(state => state.session);
    const [group, setGroup ] = useState(null)
    const userProfileChatRef = useRef(chatUserProfile)

    useEffect(() => {
        userProfileChatRef.current = chatUserProfile;
    }, [chatUserProfile])

    useEffect(() => {
       listenGroup(receiveRemoteGroup)

    }, [])
    useEffect(() => {
        if(userProfile && participants.length === 1 && !remoteGroup){
            LiveLike.createChatRoom({
                title: 'group',
                content_filter: 'none',
                accessToken: userProfile.access_token,
                visibility: 'everyone' }).then(result => {
                dispatch(setRemoteGroup(result))
                LiveLike.joinChatRoom({ roomId:result.id, accessToken: userProfile.access_token }).then(result => {
                    setGroup(result.id)
                }).catch(e => console.log('Joined is false ', e))
            }).catch(error => console.log('error ', error ))
        }else{
            if(remoteGroup){
                setGroup(remoteGroup.id)
            }

        }
    }, [userProfile,participants])

    const receiveRemoteGroup = (data) => {
        if(!remoteGroup){
            console.log('receive remote group')
            console.log('data ',data.data.message.id)
            dispatch(setRemoteGroup(data.data.message))
            LiveLike.joinChatRoom({ roomId: data.data.message.id, accessToken: userProfileChatRef.current.access_token }).then(result => {
                console.log('joined to room ', result)
                setGroup(data.data.message.id)
            }).catch(e => {
                console.log('Joined is false ', e)
                setGroup(data.data.message.id)
            })
        }else{
            setGroup(data.data.message.id)
        }
    }

    if(group === null) return <div>Empty room </div>

    return  <livelike-chat messagemenus showavatar avatarurl={avatar || blueRobot}  roomId={remoteGroup.id}>
        <div slot="message-list-empty">
            <h1 style={{color: '#fff'}}>
                Noch keine Nachrichten.
            </h1>
        </div>
    </livelike-chat>
}

export default GroupChat;

 /// rJMXGDTvEpiSoTWkXHRBvetoaRiXLW112bi6gnQ4iiDpqu7h57V_TQ